export default {"src":"/_next/static/media/ghost.dc1b6048.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};